export default "__VITE_ASSET__7228cbd3__"